<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-money-bill-transfer"></i></span>{{ 'Menu.Menu.ExchangeRate' | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ExchangeRate.Search.ExchangeType' | translate }}</label>
              <p-dropdown
                formControlName="rateType"
                [options]="rateTypeOptions"
                [filter]="true"
                [(ngModel)]="searchParams.rateType"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              >
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ExchangeRate.Search.OriginCurrency' | translate }}</label>
              <p-dropdown
                formControlName="fromCurrency"
                [options]="currencyOptions"
                [filter]="true"
                [(ngModel)]="searchParams.fromCurrency"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              >
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ExchangeRate.Search.ConversionCurrency' | translate }}</label>
              <p-dropdown
                formControlName="toCurrency"
                [options]="currencyOptions"
                [filter]="true"
                [(ngModel)]="searchParams.toCurrency"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              >
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ExchangeRate.Search.Effective' | translate }}</label>
              <p-dropdown
                formControlName="isActivated"
                [options]="isActivatedOptions"
                [(ngModel)]="searchParams.isActivated"
                [showClear]="true"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              >
              </p-dropdown>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchClickBtn($event)"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Reset' | translate }}"
                (click)="resetClickBtn($event)"
                class="p-button-secondary ml-2"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'ExchangeRate.Button.New' | translate }}"
                (click)="addClickBtn($event)"
                class="ml-2"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'ExchangeRate.Button.Import' | translate }}"
                (click)="importClickBtn($event)"
                class="ml-4"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'ExchangeRate.Button.Export' | translate }}"
                [disabled]="dailyRateRows.length === 0"
                (click)="exportClickBtn($event)"
                class="ml-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        [tableKey]="preferenceKey"
        [selectable]="false"
        [value]="dailyRateRows"
        [defaultColumns]="columns"
        [loading]="isLoading"
      >
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'rateType'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: rateTypeOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'fromCurrency'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: currencyOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'toCurrency'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: currencyOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'date'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'isActivated'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: isActivatedOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'updateDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'action'">
                <div *ngIf="rowData['rateType'] == 'CUSTOMS'">
                  <span class="icon" (click)="actionBtnClick($event, rowData)"
                    ><i class="fas fa-book"></i
                  ></span>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | date
                            : "yyyy-MM-dd HH:mm:ss"
                            : this.laasSetting.facilityTimeZone
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
  <ng-container *ngIf="isShowImportdailyRateModal">
    <laas-daily-rate-setting-import
      [(visible)]="isShowImportdailyRateModal"
      (importClick)="importdailyRate($event)"
    ></laas-daily-rate-setting-import>
  </ng-container>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
